export const lxMap = {
    // 对于未在配置平台埋点的页面，pv上报时cid统一用defaultCid所对应的cid，以此来防止pv遗漏
    defaultCid: ''
};

export const OncallReportMap = {
    click_import_oncall: 'b_techportal_lhflorqy_mc',
    submit_import_oncall: 'b_techportal_cjl7wfda_mc',
    edit_date_oncall: 'b_techportal_6grctl2x_mc',
    submit_date_oncall: 'b_techportal_37njk2kw_mc',
    click_online: 'b_techportal_rqhfpin5_mc',
    click_offline: 'b_techportal_h2f62gl6_mc',
    click_switch_oncall: 'b_techportal_mna3ncbk_mc',
    submit_switch_oncall: 'b_techportal_mi1iuxbw_mc',
    query_historical_oncall: 'b_techportal_etrm1wam_mc'
};
